
import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData, updateData, deleteData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import { TableCell, TableContainer, Tooltip, Paper, Table, TableHead, TableBody, TableRow } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Modal from '@mui/material/Modal';
import Select from 'react-select';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Button, CircularProgress, Card } from "@mui/material";

const EmployeeEdit = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const [formData, setFormData] = useState({});
    useEffect(() => {
        fetchData('EmployeeApi', `/EmployeeData/${id}`, token)
            .then((response) => {
                console.log('API response:', response);
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }, [id, userId, token]);

    const submitData = async () => {
        // Update CreatedBy field
        setFormData((prevData) => ({
            ...prevData,
            CreatedBy: userId,
        }));
        // Validate mandatory fields
        if (!formData.EmployeeName) {
            alert('Name is required.');
            return;
        }
        if (!formData.EmployeeCode) {
            alert('CGST Rate is required.');
            return;
        }
        // Update data
        try {
            const response = await updateData('EmployeeApi', id, formData, token);
            console.log('Record updated successfully:', response);
            setSuccessMessage('Record updated successfully.');
            setTimeout(() => setSuccessMessage(''), 3000);
            history.push('/EmployeeIndex');
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };

    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        const updatedFormData = {
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        };
        setFormData(updatedFormData);
    };

    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [dropdownDepartmentOptions, setDropdownDepartmentOptions] = useState([]);

    const [selectedDesignation, setSelectedDesignation] = useState("");
    const [dropdownDesignationOptions, setDropdownDesignationOptions] = useState([]);

    useEffect(() => {
        fetchDropdownDiscTypeOptions();
        fetchDropdownDesignationOptions();
    }, []);

    const fetchDropdownDiscTypeOptions = () => {
        fetchData('DepartmentApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownDepartmentOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Department dropdown options:', error);
            });
    };

    const fetchDropdownDesignationOptions = () => {
        fetchData('DesignationApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownDesignationOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Designation dropdown options:', error);
            });
    };

    const months = [
        { value: '1', label: 'January' },
        { value: '2', label: 'February' },
        { value: '3', label: 'March' },
        { value: '4', label: 'April' },
        { value: '5', label: 'May' },
        { value: '6', label: 'June' },
        { value: '7', label: 'July' },
        { value: '8', label: 'August' },
        { value: '9', label: 'September' },
        { value: '10', label: 'October' },
        { value: '11', label: 'November' },
        { value: '12', label: 'December' },
    ];

    // Convert ID to label
    const selectedMonthLabel1 = months.find(
        (month) => month.value === formData.ProfessionalTaxMonth1
    )?.label || ''; // fallback to empty string if not found

    // Convert ID to label
    const selectedMonthLabel2 = months.find(
        (month) => month.value === formData.ProfessionalTaxMonth2
    )?.label || ''; // fallback to empty string if not found    


    return (
        <Fragment>
            {/* Top Header Section */}

            <div className=" flex justify-between items-center" style={{ marginTop: '-5px' }}>
                <h6 className='block uppercase tracking-wide text-blue-500 productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    👤 Employee Edit
                </h6>

                <div className="flex gap-2">
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={submitData}
                        disabled={isLoading}
                        sx={{ borderRadius: "8px", height: "26px" }}
                    >
                        {isLoading ? (
                            <CircularProgress size={20} color="inherit" />
                        ) : (
                            "💾 Update"
                        )}
                    </Button>
                    <Button
                        variant="outlined"
                        color="error"
                        component={Link}
                        to="/EmployeeIndex"
                        onClick={() => localStorage.setItem("shouldReload", "true")}
                        sx={{ borderRadius: "8px", height: "26px" }}
                    >
                        ← Back
                    </Button>
                </div>
            </div>

            {/* Message Section */}
            {errorMessage && (
                <p className="text-red-500 mt-2 font-medium">{errorMessage}</p>
            )}
            {successMessage && (
                <p className="text-green-600 mt-2 font-medium">{successMessage}</p>
            )}

            {/* Main Form Card */}
            <Card
                sx={{
                    mt: 3,
                    p: 3,
                    borderRadius: 3,
                    boxShadow: 3,
                    border: "1px solid #e0e0e0",
                    background: "#fafbfc",
                    marginTop: '10.5px'
                }}
            >
                {/* Section 1 - Basic Info */}
                <div className="mb-6 overflow-x-auto">
                    <h6 className="text-blue-800 mb-3 border-b pb-1 uppercase" style={{ fontFamily: 'monospace', marginTop: '-5px' }}>
                        Employee Information
                    </h6>
                    <div className="w-full mb-2 flex" >
                        <div className="w-2/4 mr-2">
                            <label className="block tracking-wide text-black text-xs mb-2">
                                Name<span className="text-red-500">*</span>
                            </label>
                            <input
                                className="border rounded-md w-full px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                value={formData.EmployeeName}
                                onChange={handleChange}
                                onClick={(e) => e.target.select()}
                                type="text"
                                placeholder="EmployeeName"
                                name='EmployeeName'
                                style={{ height: '29px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-xs mb-2">
                                Employee Code<span className="text-red-500">*</span>
                            </label>
                            <input
                                className="border rounded-md w-full px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                value={formData.EmployeeCode}
                                onChange={handleChange}
                                onClick={(e) => e.target.select()}
                                type="text"
                                placeholder="Employee Code"
                                name='EmployeeCode'
                                style={{ height: '29px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-xs mb-2">
                                Department
                            </label>
                            <select
                                className="border rounded w-full focus:shadow-outline custom-select fade-in"
                                value={selectedDepartment || formData.DepartmentId || ''}
                                style={{
                                    height: '29px',
                                    fontSize: '13px',
                                    padding: '0 6px',
                                    lineHeight: '1.2'
                                }}
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    const selectedDept = dropdownDepartmentOptions.find(
                                        (dept) => dept.Id.toString() === selectedValue
                                    );

                                    setSelectedDepartment(selectedValue);
                                    setFormData((prevFormData) => ({
                                        ...prevFormData,
                                        DepartmentId: selectedValue,
                                        DepartmentName: selectedDept ? selectedDept.Name : '',
                                    }));
                                }}
                            >
                                <option value="">Department</option>
                                {dropdownDepartmentOptions.map((category) => (
                                    <option key={category.Id} value={category.Id}>
                                        {category.Name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-xs mb-2">
                                Designation
                            </label>
                            <select
                                className="border rounded w-full focus:shadow-outline custom-select fade-in"
                                value={selectedDesignation || formData.DesignationId || ''}
                                style={{
                                    height: '29px',
                                    fontSize: '13px',
                                    padding: '0 6px',
                                    lineHeight: '1.2'
                                }}
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    const selectedDept = dropdownDesignationOptions.find(
                                        (dept) => dept.Id.toString() === selectedValue
                                    );

                                    setSelectedDesignation(selectedValue);
                                    setFormData((prevFormData) => ({
                                        ...prevFormData,
                                        DesignationId: selectedValue,
                                        DesignationName: selectedDept ? selectedDept.Name : '',
                                    }));
                                }}
                            >
                                <option value="">Designation</option>
                                {dropdownDesignationOptions.map((category) => (
                                    <option key={category.Id} value={category.Id}>
                                        {category.Name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-xs mb-2">
                                UAN No
                            </label>
                            <input
                                className="border rounded-md w-full px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                value={formData.UANNo}
                                onChange={handleChange}
                                onClick={(e) => e.target.select()}
                                type="text"
                                placeholder="UAN No"
                                name='UANNo'
                                style={{ height: '29px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-xs mb-2">
                                ESI No
                            </label>
                            <input
                                className="border rounded-md w-full px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                value={formData.ESINo}
                                onChange={handleChange}
                                onClick={(e) => e.target.select()}
                                type="text"
                                placeholder="ESI No"
                                name='ESINo'
                                style={{ height: '29px' }}
                            />
                        </div>

                    </div>

                </div>

                {/* Section 2 - Pay Structure */}
                <div className="mb-6">
                    <h6 className="text-blue-800 mb-3 border-b pb-1 uppercase" style={{ fontFamily: 'monospace', marginTop: '-5px' }}>
                        Salary Structure
                    </h6>
                    <div className="grid grid-cols-7 gap-4">
                        {[
                            { name: "MonthlyLeaveCount", label: "Monthly Leave Count" },
                            { name: "WageRate", label: "Basic Payable" },
                            { name: "BasicRate", label: "Basic Rate" },
                            { name: "DARate", label: "DA Rate" },
                            { name: "HRARate", label: "HRA Rate" },
                            { name: "TARate", label: "TA Rate" },
                            { name: "OtherAllowance", label: "Other Allowance" }
                        ].map((f) => (
                            <div key={f.name}>
                                <label className="block tracking-wide text-black text-xs mb-2">
                                    {f.label}
                                </label>
                                <input
                                    type="number"
                                    name={f.name}
                                    value={formData[f.name] !== undefined ? formData[f.name] : 0} // fallback to 0 if undefined
                                    onChange={handleChange}
                                    onFocus={(e) => e.target.select()} // better UX
                                    placeholder={f.label}
                                    min={0} // prevent negative values
                                    step="any" // allow decimals
                                    style={{ height: '29px' }}
                                    className="border rounded-md w-full px-3 py-2 text-right text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Section 3 - Deductions */}
                <div className="mb-6">
                    <h6 className="text-blue-800 mb-3 border-b pb-1 uppercase" style={{ fontFamily: 'monospace', marginTop: '-5px' }}>
                        Deductions & Benefits
                    </h6>
                    <div className="grid grid-cols-5 gap-4">
                        {[
                            { name: "Arrears", label: "Arrears" },
                            { name: "Incentive", label: "Incentive" },
                            { name: "LWF", label: "LWF" },
                            // { name: "ProfessionalTax", label: "Professional Tax" },
                            // { name: "TDS", label: "TDS" }
                        ].map((f) => (
                            <div key={f.name}>
                                <label className="block tracking-wide text-black text-xs mb-2">
                                    {f.label}
                                </label>
                                <input
                                    type="number"
                                    name={f.name}
                                    value={formData[f.name] !== undefined ? formData[f.name] : 0} // fallback to 0 if undefined
                                    onChange={handleChange}
                                    onFocus={(e) => e.target.select()} // better UX
                                    placeholder={f.label}
                                    min={0} // prevent negative values
                                    step="any" // allow decimals
                                    style={{ height: '29px' }}
                                    className="border rounded-md w-full px-3 py-2 text-right text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                />
                            </div>
                        ))}
                        {/* <div className="w-4/5 mr-2">
                            <label className="block tracking-wide text-black text-xs mb-2">
                                Prof. Tax Deductions Month 1
                            </label>
                            <select
                                className="border rounded w-full focus:shadow-outline custom-select fade-in"
                                value={formData.ProfessionalTaxMonth1 || ''}
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setFormData((prevFormData) => ({
                                        ...prevFormData,
                                        ProfessionalTaxMonth1: selectedValue,
                                    }));
                                }}
                                name="ProfessionalTaxMonth1"
                                style={{
                                    height: '29px',
                                    fontSize: '13px',
                                    padding: '0 6px',
                                    lineHeight: '1.2',
                                }}
                            >
                                <option value="">Select Month</option>
                                {months.map((month) => (
                                    <option key={month.value} value={month.value}>
                                        {month.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="w-4/5 mr-2">
                            <label className="block tracking-wide text-black text-xs mb-2">
                                Prof. Tax Deductions Month 2
                            </label>
                            <select
                                className="border rounded w-full focus:shadow-outline custom-select fade-in"
                                value={formData.ProfessionalTaxMonth2 || ''}
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setFormData((prevFormData) => ({
                                        ...prevFormData,
                                        ProfessionalTaxMonth2: selectedValue,
                                    }));
                                }}
                                name="ProfessionalTaxMonth2"
                                style={{
                                    height: '29px',
                                    fontSize: '13px',
                                    padding: '0 6px',
                                    lineHeight: '1.2'
                                }}
                            >
                                <option value="">Select Month</option>
                                {months.map((month) => (
                                    <option key={month.value} value={month.value}>
                                        {month.label}
                                    </option>
                                ))}
                            </select>
                        </div> */}

                        <div className="flex items-center mt-6">
                            <input
                                type="checkbox"
                                name="IsFullPF"
                                checked={formData.IsFullPF}
                                onChange={handleChange}
                                className="w-5 h-5 accent-blue-600 mr-2"
                                style={{ cursor: 'pointer' }}
                            />
                            <label className="font-semibold text-gray-700">
                                Full PF Applicable
                            </label>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="text-center text-sm text-gray-500 mt-6 border-t pt-2">
                    <CopyrightIcon
                        fontSize="small"
                        className="inline-block text-gray-400 mr-1"
                    />
                    <b className="font-serif">EFFTABS SOLUTIONS LLP</b>
                </div>
            </Card>
        </Fragment >
    );
};



export default EmployeeEdit;